export default __webpack_public_path__ + "static/media/self2-image.9581e611.png";